import { Layout } from "../Layout";
import { useAuth } from "../../hooks/useAuth";
import { SettingsMenu } from "./SettingsMenu";

export const AccountShell = ({ title, subtitle, children, testid }) => {
  const { user, startLogin, loading } = useAuth();

  return (
    <Layout>
      <section className="max-w-5xl mx-auto px-6 lg:px-8 py-12 md:py-16" data-testid={testid}>
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-5 mb-10">
          <div>
            <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight text-[#0F0F0F]">
              {title}
            </h1>
            {subtitle && <p className="text-[#687280] mt-2 max-w-xl">{subtitle}</p>}
          </div>
          {user && <SettingsMenu />}
        </div>

        {!user && !loading ? (
          <div className="bg-[#F7F7F7] rounded-2xl p-10 text-center" data-testid="account-signin-required">
            <p className="font-display text-xl font-bold text-[#0F0F0F]">Sign in to view this page</p>
            <p className="text-sm text-[#687280] mt-1.5">
              Sign in with Google to manage your account, plans and billing.
            </p>
            <button
              onClick={startLogin}
              className="mt-5 inline-flex items-center justify-center gap-2 bg-[#0F0F0F] text-white rounded-full px-6 py-3 text-sm font-semibold hover:bg-[#1c1c1c] transition-colors"
              data-testid="account-signin-btn"
            >
              Continue with Google
            </button>
          </div>
        ) : (
          user && children
        )}
      </section>
    </Layout>
  );
};
